import { com } from '@eidu/form'
import { useParams } from 'react-router-dom'
import { requireNotUndefinedOrNull } from '../../util/require'
import EntityNotAccessibleError from './EntityNotAccessibleError'
import LoadingOverlay from '../../components/feedback/LoadingOverlay'
import EntityTypeNotAccessibleError from './EntityTypeNotAccessibleError'
import { getKindPageConfig } from './kindViewRegistry'
import useEntity from './useEntity'
import EntityId = com.eidu.sharedlib.entity.EntityId
import EntityTypeId = com.eidu.sharedlib.entity.type.EntityTypeId
import entityIdFromString = com.eidu.sharedlib.entity.entityIdFromString
import entityTypeIdFromString = com.eidu.sharedlib.entity.type.entityTypeIdFromString

type ViewEntityPageProps = {
  entityId: EntityId
  entityTypeId: EntityTypeId
}

const ViewEntityPage = ({ entityId, entityTypeId }: ViewEntityPageProps) => {
  const { entityType, entityTypes, entity, fields, loading } = useEntity({ entityTypeId, entityId })

  const ViewPage = entityType ? getKindPageConfig(entityType.kind).ViewPage : undefined

  return (
    <>
      {entity && entityType && entityTypes && ViewPage && (
        <ViewPage entity={entity} entityType={entityType} entityTypes={entityTypes} fields={fields} />
      )}
      {!loading && (!entityType || !entityTypes) && <EntityTypeNotAccessibleError />}
      {!loading && entityType && entityTypes && !entity && <EntityNotAccessibleError />}
      <LoadingOverlay isOpen={loading} />
    </>
  )
}

const ViewEntityPageRoute = () => {
  const params = useParams()
  const entityTypeId = entityTypeIdFromString(requireNotUndefinedOrNull(params.entityTypeId))
  const entityId = entityIdFromString(requireNotUndefinedOrNull(params.entityId, 'Entity ID is required'))

  return <ViewEntityPage entityTypeId={entityTypeId} entityId={entityId} />
}

export default ViewEntityPageRoute
